import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import HowItWorks from '../components/HowItWorks';
import FeaturesGrid from '../components/FeaturesGrid';
import Roles from '../components/Roles';
import HekaAI from '../components/HekaAI';
import TrustSection from '../components/TrustSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO, { commonJsonLd } from '@shared/components/seo/SEO';
import '../styles/landing.css';

const TOP_FAQ = [
  {
    q: 'What is Heka.care?',
    a: "Heka.care is Ghana's national telehealth platform. Patients book MDC-verified doctors, fill digital prescriptions, order lab tests and pharmacy delivery, and use their NHIS card online.",
  },
  {
    q: 'Is telemedicine available in Ghana?',
    a: 'Yes — across all 16 regions via Heka.care. Video consultations, home-visit nurses, pharmacy delivery, and NHIS-claim filing are available today.',
  },
  {
    q: 'Can I use my NHIS card on Heka.care?',
    a: 'Yes. Heka.care verifies your NHIS card with NHIA in real time and files claims for covered services. You pay nothing out of pocket at accredited partner facilities.',
  },
  {
    q: 'How do I book a doctor online in Ghana?',
    a: 'Sign up for free, pick a specialty or describe your symptoms, choose an available clinician, and confirm. Video consultations start the moment your clinician joins.',
  },
];

export default function LandingPage() {
  const jsonLd = [
    commonJsonLd.organization,
    commonJsonLd.website,
    {
      '@context': 'https://schema.org',
      '@type': 'MedicalWebPage',
      name: "Heka.care — Ghana's National Telehealth Platform",
      url: 'https://heka.care',
      lastReviewed: new Date().toISOString().slice(0, 10),
      audience: { '@type': 'PeopleAudience', geographicArea: { '@type': 'Country', name: 'Ghana' } },
      mainContentOfPage: {
        '@type': 'WebPageElement',
        about: 'Telemedicine, NHIS claims, digital prescriptions, pharmacy delivery, and home nursing services in Ghana.',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: TOP_FAQ.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

  return (
    <>
      <SEO
        title="Heka.care — Ghana's national telehealth platform"
        description="Book MDC-verified doctors online, fill digital prescriptions, use your NHIS card, order pharmacy delivery, and access AI-assisted care across Ghana — Accra, Kumasi, Tema, Takoradi and all 16 regions."
        path="/"
        keywords="telemedicine Ghana, telehealth Ghana, online doctor Ghana, NHIS online, video consultation Ghana, pharmacy delivery Accra, home nursing Ghana, e-prescription Ghana, virtual doctor Accra, Heka"
        includeSiteName={false}
        jsonLd={jsonLd}
      />
      <Navigation />
      <Hero />
      <Stats />
      <HowItWorks />
      <FeaturesGrid />
      <Roles />
      <HekaAI />
      <TrustSection />
      <CTASection />
      <Footer />
    </>
  );
}
